export default {
  addTag: (name: string): void => {
    if (!process.env.NEXT_PUBLIC_HOTJAR_ID) return;
    const windowObj = window as any;
    if (windowObj.hj) windowObj.hj('event', name);
  },
};
